import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '~/lib/utils';

const CircleToggle = ({ className, checked, ...props }) => (
	<span className={cn('relative inline-flex items-center align-middle', className)}>
		<input
			type="checkbox"
			checked={checked}
			className="peer sr-only"
			{...props}
		/>
		<span
			className={cn(
				'inline-block h-3 w-3 cursor-pointer rounded-full border border-transparent transition-all duration-150',
				'peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-ring peer-focus:ring-offset-2 peer-focus:ring-offset-transparent',
				checked ? 'bg-primary hover:opacity-80' : 'bg-border hover:bg-muted-foreground'
			)}
		/>
	</span>
);

CircleToggle.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool
};

export default CircleToggle;
